var MensajeConfig = (function () {
    function MensajeConfig(titulo, visibleOk, okLabel, visibleCancelar, cancelLabel, visibleCon) {
        if (visibleOk === void 0) { visibleOk = true; }
        if (okLabel === void 0) { okLabel = "Aceptar"; }
        if (visibleCancelar === void 0) { visibleCancelar = true; }
        if (cancelLabel === void 0) { cancelLabel = "Cancelar"; }
        if (visibleCon === void 0) { visibleCon = false; }
        this.titulo = titulo;
        this.visibleOk = visibleOk;
        this.okLabel = okLabel;
        this.visibleCancelar = visibleCancelar;
        this.cancelLabel = cancelLabel;
        this.visibleCon = visibleCon;
    }
    return MensajeConfig;
}());
export { MensajeConfig };
export var BUTTON_CLICK = {
    "Continuar": "CON",
    "Aceptar": "OK",
    "Cancelar": "CAN"
};
//# sourceMappingURL=mensaje.config.js.map